/**
 * Componente para el modal de confirmación de eliminación de productos
 */

if ( typeof RangoRemoveModal !== 'function' ) {

	class RangoRemoveModal extends HTMLElement {
		
		constructor() {
			super();
			this.init();
		}

		init() {
			this.closeButtons = this.querySelectorAll('[data-js-close-modal]');
			this.cancelButton = this.querySelector('[data-js-cancel]');
			this.confirmButton = this.querySelector('[data-js-confirm]');
			this.messageEl = this.querySelector('[data-rango-modal-message]');
			
			// Event listeners
			this.closeButtons.forEach(btn => {
				btn.addEventListener('click', () => this.close());
			});
			
			if (this.cancelButton) {
				this.cancelButton.addEventListener('click', () => this.close());
			}
			
			if (this.confirmButton) {
				this.confirmButton.addEventListener('click', () => this.confirm());
			}
			
			// Cerrar con ESC
			document.addEventListener('keydown', (e) => {
				if (e.key === 'Escape' && !this.hasAttribute('aria-hidden')) {
					this.close();
				}
			});
		}

		show(item, productosAfectados, rangosAfectados) {
			this.item = item;
			this.productosAfectados = productosAfectados;
			this.rangosAfectados = rangosAfectados;
			
			const isReduction = item._reducedFrom !== undefined;
			const newQuantity = isReduction ? item.quantity : 0;
			const oldQuantity = isReduction ? item._reducedFrom : (item.quantity || 0);
			
			let mensaje = '';
			if (isReduction) {
				mensaje = `Reducir la cantidad de ${oldQuantity} a ${newQuantity} hará que pierdas acceso `;
			} else {
				mensaje = 'Eliminar este producto hará que pierdas acceso ';
			}
			
			if (rangosAfectados.length === 1) {
				mensaje += `al Rango ${rangosAfectados[0]}. `;
			} else {
				mensaje += `a los Rangos ${rangosAfectados.join(' y ')}. `;
			}
			mensaje += 'Los artículos de ese rango se retirarán del carrito.';
			
			if (this.messageEl) {
				this.messageEl.textContent = mensaje;
			}
			
			this.style.display = 'flex';
			setTimeout(() => {
				this.removeAttribute('aria-hidden');
				document.body.style.overflow = 'hidden';
			}, 10);
			
			if (this.cancelButton) {
				setTimeout(() => {
					this.cancelButton.focus();
				}, 20);
			}
		}

		close() {
			this.setAttribute('aria-hidden', 'true');
			document.body.style.overflow = '';
			
			setTimeout(() => {
				this.style.display = 'none';
			}, 200);
			
			const cartProductQuantity = document.querySelector('cart-product-quantity[data-disabled]');
			if (cartProductQuantity) {
				cartProductQuantity.removeAttribute('data-disabled');
			}
			
			this.item = null;
			this.productosAfectados = null;
			this.rangosAfectados = null;
		}

		async confirm() {
			if (!this.item) {
				this.close();
				return;
			}
			
			const itemToModify = this.item;
			const productosAfectados = Array.isArray(this.productosAfectados) ? this.productosAfectados : [];
			const isReduction = itemToModify._reducedFrom !== undefined;
			const newQuantity = isReduction ? itemToModify.quantity : 0;
			
			const cartForm = document.getElementById('AjaxCartForm');
			if (!cartForm) {
				this.close();
				return;
			}
			
			this.close();
			
			if (isReduction) {
				const itemElement = cartForm.querySelector(`[data-id="${itemToModify.key}"]`);
				if (itemElement) {
					await cartForm.updateCartQty(itemElement, newQuantity, true);
					await new Promise(resolve => {
						const listener = () => {
							cartForm.removeEventListener('cart-updated', listener);
							resolve();
						};
						cartForm.addEventListener('cart-updated', listener);
						setTimeout(() => {
							cartForm.removeEventListener('cart-updated', listener);
							resolve();
						}, 2000);
					});
				}
			}
			
			const itemsToRemove = isReduction 
				? productosAfectados.filter(item => item !== null && item !== undefined)
				: [...productosAfectados, itemToModify].filter(item => item !== null && item !== undefined);
			
			if (itemsToRemove.length === 0) {
				return;
			}
			
			const itemsWithLines = itemsToRemove
				.map(item => {
					if (!item || !item.key) return null;
					const element = document.querySelector(`[data-id="${item.key}"]`);
					if (element && element.dataset.line) {
						return {
							element: element,
							line: parseInt(element.dataset.line)
						};
					}
					return null;
				})
				.filter(item => item !== null && item.element && !isNaN(item.line));
			
			if (itemsWithLines.length === 0) {
				return;
			}
			
			itemsWithLines.sort((a, b) => b.line - a.line);
			
			for (const { element } of itemsWithLines) {
				if (!element || !cartForm.updateCartQty) continue;
				
				try {
					await new Promise((resolve) => {
						const onCartUpdated = () => {
							cartForm.removeEventListener('cart-updated', onCartUpdated);
							setTimeout(() => resolve(), 150);
						};
						cartForm.addEventListener('cart-updated', onCartUpdated, { once: true });
						cartForm.updateCartQty(element, 0);
						setTimeout(() => {
							cartForm.removeEventListener('cart-updated', onCartUpdated);
							resolve();
						}, 3000);
					});
					await new Promise(resolve => setTimeout(resolve, 100));
				} catch (error) {
					console.error('Error eliminando item:', error);
				}
			}
			
			if (typeof window.RangosSystem !== 'undefined') {
				await window.RangosSystem.loadCart();
			}
		}
	}

	if ( typeof customElements.get('rango-remove-modal') == 'undefined' ) {
		customElements.define('rango-remove-modal', RangoRemoveModal);
	}

}

